// Progress milestones (chariot.serve + generate/pipeline.py), each written when
// the stage STARTS:
//   12.5 resolve + library lookup · 25 waiting for a concurrent generation of
//   the same drug (peer wait) · 50 literature search · 87.5 synthesis ·
//   95 decision support · 100 finalize.
// Anything below 50 is not generation yet.

export const PEER_WAIT_PROGRESS = 25;
export const GENERATION_STARTS_AT = 50;

// The subtitle must describe what the backend is really doing: before 50 the
// drug is only being resolved (seconds, up to ~30 s on a cold start), so
// promising "kilka minut" there made a normal lookup look stuck.
export function waitingCopy(progress: number): string {
  if (progress === PEER_WAIT_PROGRESS) {
    return "Ten raport właśnie powstaje dla innego wyszukiwania — czekamy na wynik.";
  }
  if (progress < GENERATION_STARTS_AT) {
    return "Rozpoznajemy lek i sprawdzamy, czy ma już raport w bibliotece. To zwykle trwa poniżej minuty.";
  }
  // The wait is per-DRUG, not per-user: this drug has no report in the library
  // yet, so one is being built now. Saying "pierwsze wyszukiwanie" read as
  // "your first search", which made every later uncached drug look broken.
  // Naming the payoff (instant on re-open) turns the wait into a one-time cost.
  return "Ten lek nie ma jeszcze raportu w bibliotece, więc tworzymy go od podstaw. To potrwa kilka minut, ale następnym razem otworzy się od razu. Możesz zostawić tę kartę otwartą.";
}
